export type PaletteId =
  'auto' | 'graph' | 'chalk' | 'observatory' | 'blueprint' | 'porcelain' | 'arcade';

export interface Palette {
  id: PaletteId;
  name: string;
  note: string;
}

/** Order shown in Settings. Colours live in styles/palettes.css. */
export const PALETTES: readonly Palette[] = [
  { id: 'auto', name: 'Auto', note: 'Graph Paper by day, Chalkboard by night' },
  { id: 'graph', name: 'Graph Paper', note: 'Blue ink, red pencil' },
  { id: 'chalk', name: 'Chalkboard', note: 'Slate and coloured chalk' },
  { id: 'observatory', name: 'Observatory', note: 'The original night sky' },
  { id: 'blueprint', name: 'Blueprint', note: 'White lines on cyanotype' },
  { id: 'porcelain', name: 'Porcelain', note: 'Cobalt on white glaze' },
  { id: 'arcade', name: 'Arcade', note: 'Cabinet glow after dark' },
];

export const isPaletteId = (x: unknown): x is PaletteId => PALETTES.some((p) => p.id === x);
